import { generate } from "shortid";

/*
    List of every Phobia in oVRcome
 */
const PHOBIA_LIST = [
  {
    id: 1,
    title: "Cynophobia",
    description: "Dogs",
    image: "cynophobia",
    text: "Fear of Dogs",
    value: 1,
  },
  {
    id: 2,
    title: "Arachnophobia",
    description: "Spiders",
    image: "arachnophobia",
    text: "Fear of Spiders",
    value: 2,
  },
  {
    id: 3,
    title: "Trypanophobia",
    description: "Needles",
    image: "trypanophobia",
    text: "Fear of Needles",
    value: 3,
  },
  {
    id: 5,
    title: "Ornithophobia",
    description: "Birds",
    image: "ornithophobia",
    text: "Fear of Birds",
    value: 5,
  },
  {
    id: 6,
    title: "Acrophobia",
    description: "Heights",
    image: "acrophobia",
    text: "Fear of Heights",
    value: 6,
  },
  {
    id: 7,
    title: "Aerophobia",
    description: "Flying",
    image: "aerophobia",
    text: "Fear of Flying",
    value: 7,
  },
  {
    id: 8,
    title: "Claustrophobia",
    description: "Enclosed spaces",
    image: "claustrophobia",
    text: "Fear of Enclosed Spaces",
    value: 8,
  },
  {
    id: 1014,
    title: "Amaxophobia",
    description: "Driving (Right-hand traffic)",
    image: "amaxophobia",
    text: "Fear of Driving",
    value: 1014,
  },
  {
    id: 1043,
    title: "Amaxophobia",
    description: "Driving (Left-hand traffic)",
    image: "amaxophobia-lh",
    text: "Fear of Driving",
    value: 1043,
  },
  {
    id: 10,
    title: "Entomophobia",
    description: "Insects",
    image: "entomophobia",
    text: "Fear of Insects",
    value: 10,
  },
  {
    id: 13,
    title: "Musophobia",
    description: "Mice and rats",
    image: "musophobia",
    text: "Fear of Mice",
    value: 13,
  },
  {
    id: 15,
    title: "Emetophobia",
    description: "Vomit",
    image: "vomiting",
    text: "Fear of Vomit",
    value: 15,
  },
  {
    id: 16,
    title: "Glossophobia",
    description: "Public speaking",
    image: "public-speaking",
    text: "Fear of Public Speaking",
    value: 16,
  },
  {
    id: 1010,
    title: "Thalassophobia",
    description: "Deep Water",
    image: "deep-water",
    text: "Fear of Deep Water",
    value: 1010,
  },
  {
    id: 1012,
    title: "Vaping",
    description: "Vaping",
    image: "vaping-addiction",
    text: "Vaping Addiction",
    value: 1012,
  },
  {
    id: 1013,
    title: "Driving",
    description: "Driving",
    image: "amaxophobia",
    text: "Allianz Driving",
    value: 1013,
  },
  {
    id: 1031,
    title: "Trypophobia",
    description: "Holes or Patterns",
    image: "trypophobia",
    text: "Fear of Holes or Patterns",
    value: 1031,
  },
];

const idsToExclude = [1012, 1013];
const PHOBIA_LIST_ALPABETICAL = [
  ...PHOBIA_LIST.filter((item) => !idsToExclude.includes(item.id)) //remove vaping program and allianz driving program from normal phobia list
    .sort((a, b) => a.description.localeCompare(b.description)),
];

const CHILD_PHOBIA_LIST = [21, 22, 24];

const DISORDER_LIST = [
  {
    title: "Social Anxiety",
    image: "social-anxiety",
    link: null,
    value: 4,
  },
  {
    title: "Panic Disorder with Agoraphobia",
    image: "programs/panic-disorder-black",
    link: null,
    value: 14,
  },
  {
    title: "Mild Depression",
    image: "programs/mild-depression",
    link: null,
    value: 1001,
  },
];

const ANXIETY_SCALE_LIST = [
  {
    id: generate(),
    label: "No Anxiety",
    icon: "emojis/grin-face",
  },
  {
    id: generate(),
    label: "Mild Anxiety",
    icon: "emojis/neutral-face",
  },
  {
    id: generate(),
    label: "Moderate Anxiety",
    icon: "emojis/sad-face",
  },
  {
    id: generate(),
    label: "Severe Anxiety",
    icon: "emojis/concerned-face",
  },
  {
    id: generate(),
    label: "Extreme Anxiety",
    icon: "emojis/crying-face",
  },
];

const PHOBIA_ACTION_MAP = {
  acrophobia: {
    id: 6,
    comfortable_lables: [
      "In high places outdoors or in nature",
      "In high places indoors",
      "High up while moving e.g. glass elevator etc.",
      "Standing near a balcony or railing",
      "Walking near exposed edges",
      "Walking up a flight of stairs",
    ],
    fear_of_labels: [
      "Falling over the edge",
      "That the structure might collapse",
      "The thought that I could jump off",
      "That the railings might break",
      "It shakes when i’m on it",
      "When what I'm standing on is shaky",
      "Something else",
    ],
  },
  aerophobia: {
    id: 7,
    comfortable_lables: [
      "Seeing a plane fly in the air",
      "Arriving and checking in at the airport",
      "Boarding a plane and preparing for take-off",
      "Taking off",
      "Cruising at altitude",
      "Landing",
    ],
    fear_of_labels: [
      "Plane crashes",
      "Being in a confined space",
      "Turbulence",
      "Not being in control",
      "I can't escape",
      "Knowing I’m really high up",
      "Something else",
    ],
  },
  social_anxiety: {
    id: 4,
    comfortable_lables: [
      "In a busy, public space",
      "Speaking to strangers or new acquaintances",
      "In a small space with others e.g. in an elevator, subway, doctor's waiting room",
      "Presenting at work, school, or public speaking",
      "At a party, public event, or social function",
      "Eating in front of people",
      "Signing documents or filling in forms in front of people",
      "Using a public toilet when you can hear or see other people",
    ],
    fear_of_labels: [
      "When attention is focused on me",
      "Meeting new people",
      "Making small talk",
      "Being teased or criticized",
      "Being watched while doing something",
      "Something else",
    ],
  },
  allianz_driving: {
    id: 1013,
    comfortable_lables: [],
    fear_of_labels: [
      "Bad road conditions",
      "Being a passenger",
      "Busy parking lot/ building",
      "Changing lanes",
      "Driving in a city",
      "Driving in bad weather conditions",
      "Driving in heavy traffic",
      "Driving on country roads",
      "Driving over a bridge",
      "Driving over an overpass",
      "Driving through a tunnel",
      "Encountering roadworks",
      "Entering a roundabout",
      "Fast driving",
      "Joining traffic",
      "Merging lanes",
      "Multi-lane highways",
      "Narrow roads",
      "Nowhere to pull over",
      "Waiting at traffic lights",
      "Something else",
    ],
  },
};

export {
  CHILD_PHOBIA_LIST,
  ANXIETY_SCALE_LIST,
  PHOBIA_LIST,
  DISORDER_LIST,
  PHOBIA_LIST_ALPABETICAL,
  PHOBIA_ACTION_MAP,
};
